module.exports = __webpack_public_path__ + "static/genopay-decomission-banner-bd48b7355447ac83108e279b7385a2a8.webp";